import React from 'react';

/**
 * The Sending glyph: Lucide send-horizontal, as the design addendum names it.
 * The sidebar's Sending icon exists on the CDN only as a PNG (both SVG paths in
 * config/assets.ts return 403), so this is the vector form of the same mark,
 * stroked in currentColor so it can take the map's violet.
 */
const SendingIcon: React.FC<{ size?: number; className?: string }> = ({ size = 20, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden
    focusable="false"
  >
    <path d="M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z" />
    <path d="M6 12h16" />
  </svg>
);

export default SendingIcon;
